enum ReconciliationStatus {
    PendingSubmission = 'PendingSubmission',
    PendingValidation = 'PendingValidation',
    Incomplete = 'Incomplete',
    Disqualified = 'Disqualified',
    Validated = 'Validated',
    NeedsReview = 'NeedsReview',
    Fulfilled = 'Fulfilled',
    Executing = 'Executing',
}

export default ReconciliationStatus;
